import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Methods = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[5]};
  width: 100%;
  min-width: 0;
`;

export const Templates = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;

export const TemplatesHeading = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1.5]};
  color: ${rawColors.text.strongEmphasis};
  ${typographyMixin("caption", 2)}
`;

/* Grid cell around the Tooltip wrapper (inline-flex, centred): stretch it so the card matches its siblings. */
export const FileCell = styled.div`
  display: flex;
  min-width: 0;

  & > * {
    flex: 1;
    min-width: 0;
    align-items: stretch;
  }
`;

export const GoalField = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;

/* GAP: design label 13/600. */
export const GoalLabel = styled.label`
  color: ${rawColors.text.highEmphasis};
  font-size: 0.8125rem;
  font-weight: 600;
`;

/* Design: min-height 96, padding 12 14, radius 14, 14/22; focus 1.5px accent border plus a 3px ring. */
export const GoalInput = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  min-height: 6rem;
  padding: ${spacing[3]} 0.875rem;
  border: 1.5px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius[14]};
  resize: none;
  font: inherit;
  font-size: 0.875rem;
  line-height: 1.375rem;
  color: ${rawColors.text.highEmphasis};

  &:focus {
    outline: none;
    border-color: ${rawColors.primary[500]};
    box-shadow: 0 0 0 3px color-mix(in srgb, ${rawColors.primary[500]} 16%, transparent);
  }
`;

export const GoalHelper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  color: ${rawColors.text.mediumEmphasis};
  ${typographyMixin("caption", 4)}

  svg {
    flex: none;
    color: ${rawColors.primary[500]};
  }
`;

/* Design: 28 tall, padding 0 10, pill, white, 1px stroke, 12px strong text. */
export const TemplateChip = styled.button`
  display: inline-flex;
  align-items: center;
  height: ${spacing[7]};
  padding: 0 ${spacing[2.5]};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.full};
  background: ${rawColors.structural.white};
  color: ${rawColors.text.strongEmphasis};
  ${typographyMixin("caption", 4)}
  cursor: pointer;

  &:hover {
    border-color: ${rawColors.primary[500]};
  }
`;

export const TemplateChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing[2]};
`;
